import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShoppingBag3"><Path fillRule="evenodd" clipRule="evenodd" d="M17 3H7V7H3V21H21V7H17V3ZM15.5 7V12H17V7H15.5ZM8.5 7V12H7V7H8.5ZM8.5 7H15.5V4.5H8.5V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag3;
